import NaluParser from '../utils/nalu-parser'
import RTCDataView from '../utils/data-view'
// @ts-ignore
import { NALu } from '../../../../xgplayer-transmuxer/src/codec/nalu'

export function receiveSEITransform (postMessage: (msg: { data: any; sei: { code: number; content: Uint8Array } }) => void) {
  const transform = new TransformStream({
    transform (encodedFrame, controller) {
      const isH265 = NaluParser.isH265VideoFrame(encodedFrame)
      const NALs = NaluParser.getNALUnits(new RTCDataView(encodedFrame.data), isH265)

      NALs.forEach(nalUnit => {
        if (nalUnit.sei) {
          const decodedSei = NALu.parseSEI(NALu.removeEPB(nalUnit.body), false)
          if (decodedSei) {
            postMessage({
              data: decodedSei,
              sei: {
                code: decodedSei.type,
                content: decodedSei.payload
              }
            })
          }
        }
      })
      controller.enqueue(encodedFrame)
    }
  })
  return transform
}

if (
  typeof self !== 'undefined' &&
  self.constructor.name === 'DedicatedWorkerGlobalScope'
) {
  self.addEventListener('rtctransform', (event: any) => {
    const { transformer } = event
    const { port } = transformer.options
    const transform = receiveSEITransform(msg => {
      port.postMessage(msg)
    })
    transformer.readable.pipeThrough(transform).pipeTo(event.transformer.writable)
  })
}
